<template>
  <section class="todo-list-container">
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="listParams"
      @handleSearch="handleSearchs"
    ></search-header>
    <nwwd-table
      @handleBatchAll="handleBatchAll"
      @handleAnswers='handleAnswers'
      @handleDelete='handleDelete'
      @handleOpen='handleOpen'
      @handleClose='handleClose'
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      v-bind="list"
      :header='header'
      :footButtons="footButtons"
    >
    </nwwd-table>
  </section>
</template>

<script>
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import nwwdTable from '@/components/mixins/nwwdTable'
import formDialog from '@/components/mixins/formDialog'
import queMixin from './queMixin.js'
import {
  mapActions
} from 'vuex'
import log from '../../../System/Log/log.js'

export default {
  name: 'QueList',
  mixins: [nwwdTable, searchHeader, baseHeader, formDialog, queMixin],
  data () {
    return {
    }
  },
  methods: {
    ...mapActions('config', ['FetchSitesOwnsite']),
    // handleOpencomment (data, index) {
    //   this.$routerLink('/interact/comment/Content?contentId=' + data.content.id)
    // },
    handleOpenNews (data, index) {
      if (data.content && data.content.urlWhole) {
        window.open(data.content.urlWhole)
      } else {
        this.$message('没有浏览地址')
      }
    },
    // 弹窗信息
    msgChange (message, fn, params) {
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        fn(params)
      }).catch(() => {})
    },
    // 搜索处理
    handleSearchs () {
      var params = this.listParams
      // console.log(params);
     if (params.datetime) {
        this.list.params.timeStart = params.datetime[0]
        this.list.params.timeEnd = params.datetime[1]
      } else {
        this.list.params.timeStart = ''
        this.list.params.timeEnd = ''
      }
      this.list.params.author = params.author
      this.list.params.close = params.close
      this.fetchCommentApi()
    },
    // 回调
    fetchContentCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.data
        this.list.totalCount = res.data.totalCount
      }
    },
    // 批量点击
    handleBatchAll (ids, btn) {
      if (ids.length > 0) {
        switch (btn.btn) {
          case 'Delete':
            // 批量删除
            this.handleDelete(ids, 1)
            break
          case 'Open':
            this.handleOpen(ids, 1)
            break
          case 'Close':
            this.handleClose(ids, 1)
            break
          default:
            break
        }
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 查看回答
    handleAnswers (data) {
      console.log(data);
      this.rowId = data.id
      this.$routerLink('/interact/queAndAns/ansList?questionId=' + data.id)
    },
    // 删除
    handleDelete (data) {
      var ids = []
      // console.log(data);
      if (data instanceof Array) {
        ids = data
      } else {
        ids = [data.id]
      }
      if (ids.length === 0) {
        this.$message('请选择需要删除的内容')
      } else {
        this.msgChange('是否确定删除选中内容？', this.fetchQuestionDelete, ids)
      }
    },
    // 开启评论
    handleOpen (data) {
      var ids = []
      // console.log(data);
      if (data instanceof Array) {
        ids = data
      } else {
        ids = [data.id]
      }
      if (ids.length === 0) {
        this.$message('请选择需要开启的内容')
      } else {
        this.msgChange('是否确定开启评论？', this.fetchQuestionOpen, ids)
      }
    },
    // 关闭评论
    handleClose (data) {
      var ids = []
      if (data instanceof Array) {
        ids = data
      } else {
        ids = [data.id]
      }
      if (ids.length === 0) {
        this.$message('请选择需要关闭的内容')
      } else {
        this.msgChange('是否确定关闭评论？', this.fetchQuestionClose, ids)
      }
    },
    // 接口访问
    // 关闭评论
    fetchQuestionClose (ids) {
      // console.log(ids);
      this.$request.fetchQuestionClose({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 开启评论
    fetchQuestionOpen (ids) {
      // console.log(ids);
      this.$request.fetchQuestionOpen({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 删除
    fetchQuestionDelete (ids) {
      // console.log(ids);
      this.$request.fetchQuestionDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchCommentApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 查询列表数量
    fetchInteractUsercommentCount (data) {
      this.$request.fetchInteractUsercommentCount(data).then(res => {
        if (res.code === 200) {
          this.reportNum = res.data.reportNum
        }
      })
    },
  },
  mounted () {
    // this.fetchInteractUsercommentCount()
  },
  activated () {
    if (this.$route.query.type === 'list') {
      this.fetchCommentApi()
      // this.fetchInteractUsercommentCount()
      this.$router.push({ query: { type: '' } })
    }
  }
}
</script>
<style lang='scss'>
.el-popover{
  .ct-pover__box{
    .ct-pover__item{
      .el-link--inner{
        .liulan{
          font-size: 14px!important;
        }
      }

    }
  }
}
.todo-list-container{

  .ct-wrap .ct-box__cont {
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    color: #666;
    align-items: center;
    justify-content: space-between;
    background-color: #f9f9f9;
  }
  .ct-wrap .ct-box .ct-box__item {
      align-items: center;
      margin-right: 30px;
  }
  .base-header-container{
    header{
      padding-bottom: 10px!important;
    }
    .list-wrap-btn.el-button.el-button--medium.is-plain{
      border-color: #e8e8e8;
      color: #333333;
      font-size: 14px;
      .jee-svg-icon{
        width: 10px;
        fill: #333333;
      }
    }
  }
}
.todo-list-order-type{
  .el-select-dropdown__wrap{
    max-height: 353px;
  }
}
.todo-list-status{
  .el-select-dropdown__wrap{
    max-height: 290px;
  }
}
</style>
